const barChartValueGetter = (params) => params.data.resultats?.competences;

export default  barChartValueGetter;